export const navData = [
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/f15c02bfeb02d15d.png?q=100', text: 'Top Offers' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/29327f40e9c4d26b.png?q=100', text: 'Grocery' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/22fddf3c7da4c4f4.png?q=100', text: 'Mobile' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/82b3ca5fb2301045.png?q=100', text: 'Fashion' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/69c6589653afdb9a.png?q=100', text: 'Electronics' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/ee162bad964c46ae.png?q=100', text: 'Home' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/0ff199d1bd27eb98.png?q=100', text: 'Appliances' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/71050627a56b4693.png?q=100', text: 'Travel' },
    { url: 'https://rukminim1.flixcart.com/flap/128/128/image/dff3f7adcf3a90c6.png?q=100', text: 'Beauty, Toys & More' }
];

export const bannerData = [
    { id: 1, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/d117a62eb5fbb8e1.jpg?q=50' },
    { id: 2, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/57267a180af306fe.jpg?q=50' },
    { id: 3, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/ae9966569097a8b7.jpg?q=50' },
    { id: 4, url: 'https://rukminim1.flixcart.com/flap/3376/560/image/f6202f13b6f89b03.jpg?q=50' }
]

export const imageURL = [
    'https://rukminim1.flixcart.com/flap/960/960/image/2f30db9425df5cec.jpg?q=50',
    'https://rukminim1.flixcart.com/flap/960/960/image/084789479074d2b2.jpg',
    'https://rukminim1.flixcart.com/flap/960/960/image/1ce0c4c1fb501b45.jpg?q=50'
];

export const brands=[
    {url: 'https://th.bing.com/th/id/OIP.U0BOpkDCuOfrPbfTPERc9QHaGH?pid=ImgDet&w=900&h=743&rs=1' },
    {url: 'https://th.bing.com/th/id/OIP.C95Moaypy72YIHJ6rnLThQHaE5?w=270&h=180&c=7&r=0&o=5&dpr=2&pid=1.7'},
    {url: 'https://th.bing.com/th/id/R.1870628828c4ac09175e1c208064b9e2?rik=VS4XkNJCEt1m1A&riu=http%3a%2f%2fwww.logosquizwalkthrough.com%2fimages%2femerging%2fgucci.jpg&ehk=M21FdfBc%2fRoP292w4T3cXTpCROi2Ed4EoRtUDQHj6rM%3d&risl=&pid=ImgRaw&r=0'},
    {url: 'https://24oclock.files.wordpress.com/2012/03/dg-logo.jpg'},
    {url: 'https://clipartcraft.com/images/levis-logo-strauss-5.png'}
]